document.addEventListener("DOMContentLoaded", function() {
    var hodnoceniDivs = document.querySelectorAll('.produkt-hodnoceni');

    hodnoceniDivs.forEach(function(div) {
        var hodnoceni = parseFloat(div.getAttribute('data-hodnoceni')); // Získání hodnocení z atributu data-hodnoceni
        var celeHvezdy = Math.floor(hodnoceni); // Celé hvězdy
        var pulHvezdy = hodnoceni - celeHvezdy; // Půl hvězdy

        for (var i = 0; i < celeHvezdy; i++) {
            var celeHvezda = document.createElement('i');
            celeHvezda.classList.add('fas', 'fa-star');
            div.appendChild(celeHvezda);
        }

        if (pulHvezdy >= 0.5) {
            var pulHvezda = document.createElement('i');
            pulHvezda.classList.add('fas', 'fa-star-half-alt');
            div.appendChild(pulHvezda);
        }
    });

    const products = document.querySelectorAll('.product');
       products.forEach(product => {
           const productID = product.getAttribute('data-id');
           initializeStars(productID);
       });

       // Odeslání hodnocení a komentářů na server
       const submitButtons = document.querySelectorAll('.product .submit-btn');
       submitButtons.forEach(button => {
           button.addEventListener('click', () => {
               const productID = button.closest('.product').getAttribute('data-id');
               const commentTextarea = document.querySelector(`.product[data-id="${productID}"] .comment`);
               const comment = commentTextarea.value;
               // Odešlete hodnocení a komentář na server pomocí AJAX nebo jiným způsobem
               console.log(`Hodnocení produktu ${productID}: ${ratings[productID]}`);
               console.log(`Komentář produktu ${productID}: ${comment}`);
           });
       });


});


// Objekt pro uchování hodnocení produktů
const ratings = {};

function initializeStars(productID) {
    const ratingStars = document.querySelector(`.product[data-id="${productID}"] .rating-stars`);
    ratings[productID] = 0; // Počáteční hodnocení je 0

    ratingStars.innerHTML = '';
    for (let i = 1; i <= 5; i++) {
        const star = document.createElement('span');
        star.className = `star ${i <= ratings[productID] ? 'fas' : 'far'} fa-star`;
        star.addEventListener('click', () => {
            ratings[productID] = i;
            updateStars(productID);
        });
        ratingStars.appendChild(star);
    }
}

function updateStars(productID) {
    const ratingStars = document.querySelector(`.product[data-id="${productID}"] .rating-stars`);

    ratingStars.innerHTML = '';
    for (let i = 1; i <= 5; i++) {
        const star = document.createElement('span');
        star.className = `star ${i <= ratings[productID] ? 'fas' : 'far'} fa-star`;
        star.addEventListener('click', () => {
            ratings[productID] = i;
            updateStars(productID);
        });
        ratingStars.appendChild(star);
    }
}


